var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[(_vm.message)?_c('div',{staticClass:"notification-container",class:_vm.currentStatus},[_c('div',{staticClass:"w100"},[_c('img',{attrs:{"src":_vm.statusImage,"alt":_vm.message}}),_c('span',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.message),expression:"message"}]})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }